export default __webpack_public_path__ + "static/media/filter.7a1a4af2.svg";